export {};
//# sourceMappingURL=INotificationManager.js.map